import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  If, Message, Produktbaustein, updateWindowHeightForIF,
  appActions,
} from 'ion-lib';
import i18next from 'i18next';

const Notfalldienste = ({
  baustein,
  bausteinIndex,
  handleChange,
}) => {
  const [showAlert, setAlert] = useState(false);
  const dispatch = useDispatch();

  return (
    baustein.relevant && (
      <>
        <Produktbaustein
          title={i18next.t('produktvergleich.zusatz.notfalldienste')}
          onClick={() => {
            if (!baustein.ueberschreibbar && !baustein.value) {
              setAlert(true);
              updateWindowHeightForIF();
            }
          }}
          tooltip={() => dispatch(appActions.toggleModal(i18next.t('produktvergleich.zusatz.notfalldienste_tt')))}
          onChange={handleChange}
          name={`daten.bausteine.${bausteinIndex}.notfalldienste.value`}
          checkbox={baustein}
        >
          <p dangerouslySetInnerHTML={{ __html: i18next.t('produktvergleich.zusatz.notfalldienste_beschreibung') }} />
        </Produktbaustein>
        <If predicate={!baustein.ueberschreibbar && showAlert}>
          <Message
            show
            dismissible
            onAfterClose={() => {
              setAlert(false);
              updateWindowHeightForIF();
            }}
            text={i18next.t('produktvergleich.zusatz.notfalldienste_alert_nichtVerfuegbar')}
            variant="dark"
          />
        </If>
      </>
    )
  );
};

export default Notfalldienste;
